import { render, staticRenderFns } from "./TransportListTemplatesBlock.vue?vue&type=template&id=b1256d90&scoped=true&"
import script from "./TransportListTemplatesBlock.vue?vue&type=script&lang=js&"
export * from "./TransportListTemplatesBlock.vue?vue&type=script&lang=js&"
import style0 from "./TransportListTemplatesBlock.vue?vue&type=style&index=0&id=b1256d90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1256d90",
  null
  
)

export default component.exports